import { useMemo } from 'react';

export const getArrayWithNonEmptyValues = <T>(value: T[] | T) => {
  const valueArray = Array.isArray(value) ? value : [value];
  return valueArray.filter(Boolean) as Exclude<T, undefined | null>[];
};

// This hook is used to memoize an array of primitive values, filtering out any falsy values.
// It takes a value that can be either an array or a single value and returns a memoized array of non-falsy values.
export const useMemoizedArray = <T>(value: T[] | T) => {
  const valueArray = getArrayWithNonEmptyValues(value);
  return useMemo(() => valueArray, [valueArray.join(',')]);
};
